import React from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import "../App.css";

const CallAction = () => {
  return (
    <div className="cta-section py-5">
      <Container>
        <Row className="justify-content-center">
          <Col lg={9} md={11}>

            <div className="cta-card text-center">

              {/* <Image
                src="/Medal.png"
                alt="Medal"
                fluid
                className="cta-image"
              /> */}

              <h3 className="fw-bold mb-3 cta-title">
                Schedule a Professional Consultation
              </h3>

              <p className="mb-4 cta-text">
                At <strong>Ndlebe Msuthu Attorneys</strong>, we provide reliable,
                professional legal guidance tailored to your needs.
                Book a consultation today to speak with our experienced team.
                <br />
                <em>(Consultation fees apply)</em>
              </p>

              <Button
                href="https://wa.me/27833030262"
                target="_blank"
                className="cta-btn rounded-pill px-5 py-2 fw-bold"
              >
                BOOK CONSULTATION
              </Button>

            </div>

          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CallAction;